export default __webpack_public_path__ + "static/media/feature4.644b5623.png";